import {Box, Typography} from '@mui/material';
import type {Job} from '@cp/model';
import formatDate, {formatDuration} from '../../../../utils/time/formatDate';

interface JobDetailDialogInfoProps {
  job: Job;
}

export default function JobDetailDialogInfo({job}: JobDetailDialogInfoProps) {
  return (
    <Box>
      <Typography variant="subtitle1" gutterBottom sx={{fontWeight: 600}}>
        Job Information
      </Typography>
      <Box sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
        <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
          <Typography variant="body2" color="text.secondary">
            Job ID:
          </Typography>
          <Typography variant="body2">{job.id}</Typography>
        </Box>
        <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
          <Typography variant="body2" color="text.secondary">
            Created:
          </Typography>
          <Typography variant="body2">{formatDate(job.createdAt)}</Typography>
        </Box>
        {job.startedAt && (
          <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
            <Typography variant="body2" color="text.secondary">
              Started:
            </Typography>
            <Typography variant="body2">{formatDate(job.startedAt)}</Typography>
          </Box>
        )}
        {job.completedAt && (
          <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
            <Typography variant="body2" color="text.secondary">
              Completed:
            </Typography>
            <Typography variant="body2">{formatDate(job.completedAt)}</Typography>
          </Box>
        )}
        {job.startedAt && (
          <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
            <Typography variant="body2" color="text.secondary">
              Duration:
            </Typography>
            <Typography variant="body2">{formatDuration(job.startedAt, job.completedAt)}</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}
